import { PublicUserFragment } from '@client/graphql/__generated__/types';
import { createContext, useContext } from 'react';

interface SharedPageContextType {
  isForPdf?: boolean;
  sharedBy?: PublicUserFragment;
  // True once the share-link token has been verified as valid and not expired.
  // Children should defer token-bound data queries until this is true so that
  // expired/invalid links are handled by SharedPage rather than the query.
  isShareLinkVerified?: boolean;
}

export const SharedPageContext = createContext<SharedPageContextType>({});

export const useSharedPageContext = () => {
  return useContext(SharedPageContext);
};
